import { useQuery } from '@tanstack/react-query';
import { fetchShipmentSpotBidAddress } from '../data-provider/spot-bid-address';
import type { GetShipmentSpotBidAddressRequestParams } from '../data-provider/spot-bid-address/api';

export const useGetSpotBidAddress = (params: GetShipmentSpotBidAddressRequestParams) => {
  return useQuery({
    queryKey: ['shipment-spot-bid-address', params.CustomerKey, params.Shipmentkey, params.RoutingType],
    queryFn: () => fetchShipmentSpotBidAddress(params),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: !!params.Shipmentkey && !!params.RoutingType && !!params.CustomerKey,
  });
};
